import { Component, OnInit } from '@angular/core';
import { ManagedContentService } from '../shared/service/managed-content.service';
import {ContentType} from '../shared/model/cm/managed-content.model';
import { Notice } from '../shared/model/session/notice';
import { PagetitleService } from '../shared/service/pagetitle.service';
import {UserSessionService} from "../shared/service/user-session.service";
import {Router} from "@angular/router";
import {GlobalConstants} from '../shared/global-constants';
import { ModalService } from '../shared/service/modal.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaintenanceComponent implements OnInit {
  public readonly pageIllustrationUrl = 'assets/Illustration-Footer-Base-Mountains.svg';
  public readonly sickComputerUrl = GlobalConstants.maintenanceLogo;
  maintenanceContent: Notice;

  constructor(private cmService: ManagedContentService,
              private pageTitleService: PagetitleService,
              public router: Router,
              private userSessionService: UserSessionService,
              private modalService: ModalService) { }

  ngOnInit(): void {
    if(this.userSessionService.data.maintenance_mode){
      let datetime = this.userSessionService.data.maintenance_time;
      let maintenanceError = this.cmService.getContentById(ContentType.HELP,"maintenance-error");
      let body = maintenanceError.body.toString().replace('MAINTENANCE_TIME', datetime)
      this.maintenanceContent = {
        id: maintenanceError.id,
        title: maintenanceError.title,
        body: body
      };
      if(this.pageTitleService){
        this.pageTitleService.setPageTitle('Maintenance Window');
      }
      if(this.modalService){
        this.modalService.closeModal('prism-ui-modal-cancel-modal');
      }
    } else {
      this.router.navigate(['instructions']);
    }
  }
}
